module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "shake"
    }
  }, [_c('div', {
    staticClass: "shakebox"
  }, [_c('div', {
    staticClass: "prize"
  }, [_c('div', {
    staticClass: "radiation"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'luckdraw/light.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main",
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/bg5.png)')
  }, [_c('div', {
    staticClass: "shacks"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'luckdraw/title-top.png'
    }
  })]), _vm._v(" "), (_vm.activeState != 1) ? [(_vm.shake_type == 'fixed') ? _c('p', {
    staticClass: "center",
    on: {
      "click": function($event) {
        return _vm.prize()
      }
    }
  }, [(_vm.remain != 0) ? _c('span', [_vm._v("您还有" + _vm._s(_vm.remain) + "次机会")]) : _c('span', [_vm._v("您的摇奖次数已达上限")])]) : _c('p', {
    staticClass: "center",
    on: {
      "click": function($event) {
        return _vm.prize()
      }
    }
  }, [(_vm.allow) ? _c('span', [_vm._v("\n              摇一摇开始抽奖\n              ")]) : _c('span', [_vm._v("\n              下一次抽奖："), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.hours2) + ":" + _vm._s(_vm.minites2) + ":" + _vm._s(_vm.seconds2))])])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "prizes",
    on: {
      "click": function($event) {
        return _vm.showPrizs()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'luckdraw/prizes.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v("我的奖品")])])]), _vm._v(" "), _c('div', {
    staticClass: "timebox"
  }, [(_vm.activeState == -1) ? _c('div', {
    staticClass: "time"
  }, [_vm._v("\n          活动开始倒计时："), _c('span', {
    staticClass: "day"
  }, [_vm._v(_vm._s(_vm.days))]), _vm._v("天"), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.hours))]), _vm._v("时"), _c('span', {
    staticClass: "minute"
  }, [_vm._v(_vm._s(_vm.minites))]), _vm._v("分"), _c('span', {
    staticClass: "second"
  }, [_vm._v(_vm._s(_vm.seconds))]), _vm._v("秒\n        ")]) : _vm._e(), _vm._v(" "), (_vm.activeState == 0) ? _c('div', {
    staticClass: "time"
  }, [_vm._v("\n          活动结束倒计时："), _c('span', {
    staticClass: "day"
  }, [_vm._v(_vm._s(_vm.days))]), _vm._v("天"), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.hours))]), _vm._v("时"), _c('span', {
    staticClass: "minute"
  }, [_vm._v(_vm._s(_vm.minites))]), _vm._v("分"), _c('span', {
    staticClass: "second"
  }, [_vm._v(_vm._s(_vm.seconds))]), _vm._v("秒\n        ")]) : _vm._e(), _vm._v(" "), (_vm.activeState == 1) ? _c('div', {
    staticClass: "time"
  }, [_vm._v("\n          ~~~~~~~活动已结束~~~~~~~\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "introduce",
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/bg4.png)')
  }, [_c('div', {
    staticClass: "rules rules_box"
  }, [_c('div', {
    staticClass: "title",
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/title-bg.png)')
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.remark),
      expression: "remark"
    }]
  }, [_vm._v("\n          " + _vm._s(_vm.remark) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("- 由美时美客提供技术支持 -")])])]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('prizes', {
    attrs: {
      "prizelist": _vm.prizelist,
      "prizeRemark": _vm.prize_remark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'close.png'
    },
    on: {
      "click": _vm.closeList
    }
  })])], 1), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.show2),
      callback: function($$v) {
        _vm.show2 = $$v
      },
      expression: "show2"
    }
  }, [_c('div', {
    staticClass: "poup center"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    on: {
      "click": _vm.cutdown
    }
  }), _vm._v("中奖信息")]), _vm._v(" "), (_vm.prizeImg) ? _c('img', {
    staticClass: "prizeImg",
    attrs: {
      "src": _vm.prizeImg
    }
  }) : _c('img', {
    staticClass: "prizeImg",
    attrs: {
      "src": _vm.imgPath + 'nothing.jpg'
    }
  }), _vm._v(" "), (_vm.prizeImg) ? _c('p', [_vm._v("恭喜您，中奖了！！！")]) : _c('p', [_vm._v("此处空空如也，请再接再厉……")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da03d81e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/shake.vue
// module id = 261
// module chunks = 0